export enum AvailableRoles {
    ROLE_TINDA_SUPER_ADMIN = 'ROLE_TINDA_SUPER_ADMIN',
    ROLE_TINDA_ADMIN = 'ROLE_TINDA_ADMIN',
    ROLE_SUPPORT_ADMIN = 'ROLE_SUPPORT_ADMIN',
    ROLE_SUPPORT_USER = 'ROLE_SUPPORT_USER',
    ROLE_MERCHANT_ADMIN = 'ROLE_MERCHANT_ADMIN',
    ROLE_MERCHANT_CASHIER = 'ROLE_MERCHANT_CASHIER',
    ROLE_MERCHANT_FORWARDER = 'ROLE_MERCHANT_FORWARDER',
    ROLE_MERCHANT_POS = 'ROLE_MERCHANT_POS',
    ROLE_MERCHANT_USER = 'ROLE_MERCHANT_USER'
}


export const RolesWithFullAccess = [
    AvailableRoles.ROLE_TINDA_SUPER_ADMIN,
    AvailableRoles.ROLE_TINDA_ADMIN,
    AvailableRoles.ROLE_SUPPORT_ADMIN,
    AvailableRoles.ROLE_SUPPORT_USER,
    AvailableRoles.ROLE_MERCHANT_ADMIN
]

export const RolesWithAccessFromLoginPage = [
    AvailableRoles.ROLE_MERCHANT_ADMIN,
    AvailableRoles.ROLE_MERCHANT_USER
]

export const RolesWithAccessFromCookies = [
    AvailableRoles.ROLE_TINDA_SUPER_ADMIN,
    AvailableRoles.ROLE_TINDA_ADMIN,
    AvailableRoles.ROLE_SUPPORT_ADMIN,
    AvailableRoles.ROLE_SUPPORT_USER
]

export const RolesWithOutAccess = [
    AvailableRoles.ROLE_MERCHANT_CASHIER,
    AvailableRoles.ROLE_MERCHANT_FORWARDER,
    AvailableRoles.ROLE_MERCHANT_POS
]


export const getRole = (roles: string[]): AvailableRoles | null => {

    for (let i = 0; i < roles.length; i++) {
        switch (roles[i]) {
            case AvailableRoles.ROLE_TINDA_SUPER_ADMIN:
                return AvailableRoles.ROLE_TINDA_SUPER_ADMIN
            case AvailableRoles.ROLE_TINDA_ADMIN:
                return AvailableRoles.ROLE_TINDA_ADMIN
            case AvailableRoles.ROLE_SUPPORT_ADMIN:
                return AvailableRoles.ROLE_SUPPORT_ADMIN
            case AvailableRoles.ROLE_SUPPORT_USER:
                return AvailableRoles.ROLE_SUPPORT_USER
            case AvailableRoles.ROLE_MERCHANT_ADMIN:
                return AvailableRoles.ROLE_MERCHANT_ADMIN
            case AvailableRoles.ROLE_MERCHANT_USER:
                return AvailableRoles.ROLE_MERCHANT_USER
            case AvailableRoles.ROLE_MERCHANT_CASHIER:
                return AvailableRoles.ROLE_MERCHANT_CASHIER
            case AvailableRoles.ROLE_MERCHANT_FORWARDER:
                return AvailableRoles.ROLE_MERCHANT_FORWARDER
            case AvailableRoles.ROLE_MERCHANT_POS:
                return AvailableRoles.ROLE_MERCHANT_POS
        }
    }

    return null
}
